module.exports = flarum.core.compat['common/Session'];